import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

import Slider from "./modules/slider";
Slider().init()

import Accordion from "./modules/accordions";
Accordion().init()

import ReviewsSlider from "./modules/reviews-slider";
ReviewsSlider().init()

import CounterSlider from "./modules/counter";
CounterSlider().init()

import LogoGallery from "./modules/logo-gallery";
LogoGallery().init()

// Templates

// Template parts

// Pages
